import { IPofTypeReponse } from 'interface/pofType.interface';
import axiosClient from './axiosClient';
import { IPagination } from 'interface/base.interface';
const path = 'abe/pof-type';

const PofTypeApi = {
  getAll: (params?: IPagination): Promise<IPofTypeReponse> => {
    return axiosClient.get(`/${path}`, { params });
  },
  getCartType: (): Promise<IPofTypeReponse> => {
    return axiosClient.get(`/${path}?is_create_cart=true`);
  },
  deleteCategory: (id: any): Promise<IPofTypeReponse> => {
    return axiosClient.delete(`abe/portfolio/${id}`);
  },
};

export default PofTypeApi;
